import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=69c8786b&scoped=true&"
import script from "./CustomSwitch.vue?vue&type=script&lang=js&"
export * from "./CustomSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8786b",
  null
  
)

export default component.exports